var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, createRef, forwardRef, useRef } from 'react';
import cn from 'classnames';
import styles from 'core-components/src/components/slider/slider.scss';
const Slider = forwardRef((props, ref) => {
    const { className, extension } = props, nativeProps = __rest(props, ["className", "extension"]);
    const _wrapper = createRef();
    const _ref = createRef();
    const _originalMax = useRef(0);
    const { min, max } = nativeProps;
    const drawProgressBar = (control) => {
        const _value = Number(control.value);
        const _min = Number(min);
        const _max = Number(_ref.current.max);
        const percent = ((_value - _min) / (_max - _min)) * 100;
        // If the current value exceeds the original max,
        // and the wrapper hasn't the 'overflow' class,
        // then add it
        if (_value >= _originalMax.current &&
            !_wrapper.current.classList.contains(styles.overflow)) {
            _wrapper.current.classList.add(styles.overflow);
        }
        // If the current value is less than the original max,
        // and the wrapper has the 'overflow' class,
        // then remove it
        else if (_value < _originalMax.current &&
            _wrapper.current.classList.contains(styles.overflow)) {
            _wrapper.current.classList.remove(styles.overflow);
        }
        // sets new percent
        _wrapper.current.style.setProperty('--current', `${percent}%`);
    };
    const changeToExtended = () => {
        const newMax = Number.parseInt(_ref.current.max, 10);
        const _min = Number.parseInt(_ref.current.min, 10);
        // Regla de tres simple. Por ejemplo:
        // min:       200
        // max:       800
        // extension: 400
        // total:     1200
        //
        // (100 * (800 - 200)) / (1200 - 200) -> 100
        const breakpoint = (100 * (_originalMax.current - _min)) / (newMax - _min);
        _wrapper.current.style.setProperty('--limit', `${breakpoint}%`);
    };
    const addExtension = () => {
        _ref.current.max = String(_originalMax.current + extension);
        changeToExtended();
        drawProgressBar(_ref.current);
    };
    useEffect(() => {
        if (ref && !ref.current) {
            // eslint-disable-next-line no-param-reassign
            ref.current = _ref.current;
        }
        if (!_originalMax.current) {
            _originalMax.current = Number(max);
        }
        if (extension) {
            addExtension();
        }
        drawProgressBar(_ref.current);
    });
    const wrapperStyles = cn({
        [styles.slider]: true,
        [styles.withExtension]: extension,
        [className]: className
    });
    return (React.createElement("div", { ref: _wrapper, className: wrapperStyles },
        React.createElement("input", Object.assign({ ref: _ref, type: "range" }, nativeProps))));
});
Slider.defaultProps = {
    min: 0,
    max: 10,
    value: 5,
    step: 1
};
export { Slider };
